import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  const previewArticles = articles.slice(0, 9);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            SEO Guides &amp; Ratgeber
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-4">
            Oopbuy Spreadsheet Wissen – Alle Guides auf einen Blick
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            Unsere ausführlichen deutschsprachigen Ratgeber helfen dir, das Beste aus deinem Oopbuy Spreadsheet herauszuholen
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {previewArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artikel/${article.slug}`}
              className="group cursor-pointer bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-white/90 text-foreground-800 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
                  {article.metaDescription}
                </p>
                <div className="flex items-center gap-1 text-xs text-primary-600 font-medium">
                  <span>Weiterlesen</span>
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {articles.length > 9 && (
          <div className="text-center mt-10">
            <span className="text-foreground-500 text-sm">
              +{articles.length - 9} weitere Guides verfügbar – besuche unsere Artikelseiten
            </span>
          </div>
        )}
      </div>
    </section>
  );
}